import { render, staticRenderFns } from "./notification-phone-reception-request-notice.vue?vue&type=template&id=24bb9c9b&"
import script from "./notification-phone-reception-request-notice.vue?vue&type=script&lang=js&"
export * from "./notification-phone-reception-request-notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports